/* eslint-disable react/no-danger */
import React from 'react';
import { sprintf } from 'sprintf';

import { assetUrl } from 'constants/global';

export const CongratulationsSection: React.FC = () => (
  <div className='px-1'>
    <h1
      className='standfirst standfirst--lead mb-1 mb-sm-3'
      dangerouslySetInnerHTML={{
        __html: sprintf(
          "Congratulations! You are now an Art Stream subscriber. Enjoy unlimited access to the entire art collection on Sedition. To get you started we've added a few %splaylists%s for you.",
          '<a href="/playlists-lg-playlist" class="link-border">',
          '</a>',
        ),
      }}
    />
    <div className='d-flex align-items-center'>
      <div className='mr-1 mr-sm-2'>
        <img src={assetUrl('logos/lg-white.png')} alt='LG' width={200} />
      </div>
      <p className='fs-lg-16 mb-0 muted'>
        View the playlist on your TV by downloading Sedition app for LG TVs; simply open the LG
        Content Store on your TV and search for 'Sedition'
      </p>
    </div>
  </div>
);
